<div class="c-card main-content">
  <div>
    <cbs-button-bar class="sticky-content"></cbs-button-bar>
    <cbs-cos [optionColumnLayout]="cos_columnCount" [singleColumnProperty]="true"></cbs-cos>
  </div>
</div>
